// 메뉴 권한 체크 — LeftComponent.authCheck 와 동일 로직의 공용 함수 (menuUrl + childMenu 1단계 탐색)
interface MenuNode {
  menuUrl?: string
  childMenu?: MenuNode[]
}

export const hasMenuAuth = (menus: MenuNode[] | null | undefined, path: string): boolean => {
  if (!menus) return false
  for (const menu of menus) {
    if (menu.menuUrl === path) return true
    if (menu.childMenu) {
      for (const child of menu.childMenu) {
        if (child.menuUrl === path) return true
      }
    }
  }
  return false
}
